import { FC, HTMLProps } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import Image from 'app/components/v2/components/Image';
import Paragraph from 'app/components/v2/components/Text/Paragraph';
import SmallBody from 'app/components/v2/components/Text/SmallBody';
import { images } from 'app/constants/images';

// Local Typings
interface Props extends Omit<HTMLProps<HTMLImageElement>, 'alt' | 'src'> {
  isBadgeFilledIn?: boolean;
  withSubHeading?: boolean;
}

// Component Definition
const LargeSelectCarrierBadge: FC<Props> = ({
  isBadgeFilledIn,
  withSubHeading = true,
  ...props
}) => {
  const { t } = useTranslation('components');

  return (
    <>
      <Image
        {...props}
        alt={t('selectCarrierBadge.imageAltText', 'Triumph Payments Select Carrier Logo')}
        src={isBadgeFilledIn ? images.selectCarrier.full : images.selectCarrierBlackWhite.full}
      />

      {withSubHeading && (
        isBadgeFilledIn
          ? (
            <Paragraph
              alignment="center"
              marginTop={4}
              textColor="light"
            >
              <Trans
                i18nKey="selectCarrierBadge.topText"
                ns="components"
                t={t}
              >
                Triumph Payments
                <br />
                Select Carrier
              </Trans>
            </Paragraph>
          )
          : (
            <SmallBody
              alignment="center"
              marginTop={4}
              textColor="light"
            >
              <Trans
                i18nKey="selectCarrierBadge.learnMore"
                ns="components"
                t={t}
              >
                Learn More About the
                <br />
                Triumph Payments Select
                <br />
                Carrier Program
              </Trans>
            </SmallBody>
          )
      )}
    </>
  );
};

export default LargeSelectCarrierBadge;
